export default {"src":"/newStatic/_next/static/media/pattern-2.695d1de7.svg","height":284,"width":113};